module.exports = __webpack_public_path__ + "static/code-snippet@1x-7eb503fa4c2765c026fb66f620c2caa3.png";